import React, { useEffect, useState, useContext, useRef } from 'react'
import { CCard, CButton, CFormSelect, CFormInput } from '@coreui/react'
import SearchTable from 'src/components/searchTable'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { isEmpty } from 'lodash'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import { AppContext } from 'src/views/context/app'
import { USER_WATCH_REPORT_API } from 'src/views/utils/urls'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { convertDuration, raiseToast } from '../../../utils/helper'

const UserContentReport = () => {
  const dateRangeRef = useRef(null)
  const { setLoader, accountObj } = useContext(AppContext)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [deviceTypeFilter, setDeviceTypeFilter] = useState('')
  const [page, setPage] = useState(1)
  const [userContentReportList, setUserContentReportList] = useState([])
  const [monthArr, setMonthArr] = useState([])
  const [monthFilterValue, setMonthFilterValue] = useState({})
  const [filterText, setFilterText] = useState('Please Select Date Range to view data!')

  let isDateRangeAllowed = accountObj?.od_resource_allowances?.enable_date_range

  const getMonthArr = async () => {
    let tempArr = []
    for (let i = 0; i < 4; i++) {
      let month = moment().subtract(i, 'months').format('MMM YYYY')

      const startOfMonth = moment(month).startOf('month').format('YYYY-MM-DD')
      const endOfMonth = moment(month).endOf('month').format('YYYY-MM-DD')
      tempArr.push({
        label: month,
        startDate: startOfMonth,
        endDate: endOfMonth,
      })
    }

    if (!isEmpty(tempArr)) {
      setMonthArr([...tempArr])
      setMonthFilterValue(tempArr[0].label)
      setStartDate(tempArr[0].startDate)
      setEndDate(tempArr[0].endDate)
      await userContentReportCall({
        params: {
          page: page,
          start_date: tempArr[0].startDate,
          end_date: tempArr[0].endDate,
        },
      })
    }
  }

  useEffect(() => {
    if (!isDateRangeAllowed) {
      getMonthArr()
    }
  }, [])

  const downloadExcel = () => {
    if (!startDate || !endDate) {
      raiseToast('error', 'Please Select a Date Range!')
      return
    }
    downloadUserContentReportCall({
      params: {
        start_date: startDate,
        end_date: endDate,
        device_type: deviceTypeFilter,
      },
    })
  }

  const applyFilter = () => {
    if (!startDate || !endDate) {
      raiseToast('error', 'Please Select a Date Range!')
      return
    }
    setPage(1)
    userContentReportCall({
      params: {
        page: 1,
        start_date: startDate,
        end_date: endDate,
        device_type: deviceTypeFilter,
      },
    })
  }

  const [
    { data: userContentReportData, loading: userContentReportLoading },
    userContentReportCall,
  ] = useAxios(
    {
      url: `${USER_WATCH_REPORT_API}?page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  const [
    { loading: downloadUserContentReportLoading, response: downloadUserContentResponse },
    downloadUserContentReportCall,
  ] = useAxios(
    {
      url: `${USER_WATCH_REPORT_API}/download`,
      method: 'get',
      responseType: 'arraybuffer',
    },
    { manual: true },
  )

  // useEffect(() => {
  //   userContentReportCall({
  //     params: {
  //       page: page,
  //     },
  //   })
  // }, [])

  useEffect(() => {
    setLoader(userContentReportLoading || downloadUserContentReportLoading)
  }, [userContentReportLoading, downloadUserContentReportLoading])

  useEffect(() => {
    if (userContentReportData && userContentReportData.success) {
      page === 1
        ? setUserContentReportList(userContentReportData.data)
        : setUserContentReportList((userContentReportList) => [
            ...userContentReportList,
            ...userContentReportData.data,
          ])

      if (page === 1 && isEmpty(userContentReportData.data)) {
        setFilterText('No User Content Report data available!')
      }
    }
  }, [userContentReportData])

  useEffect(() => {
    if (downloadUserContentResponse && downloadUserContentResponse.status === 200) {
      const blob = new Blob([downloadUserContentResponse.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `user-content-report.xlsx`
      link.click()
    }
  }, [downloadUserContentResponse])

  const resetFilters = () => {
    if (dateRangeRef.current) {
      dateRangeRef.current.$picker[0].value = ''
    }
    setPage(1)
    setStartDate('')
    setEndDate('')
    setDeviceTypeFilter('')
    setUserContentReportList([])
    setFilterText('Please Select Date Range to view data!')
    // userContentReportCall({
    //   params: {
    //     page: 1,
    //   },
    // })
  }

  const tableConfig = [
    {
      header: 'Title',
      dataCell: (info) => info.title,
      width: 29,
    },
    {
      header: 'Content ID',
      dataCell: (info) => info.content_id,
      width: 20,
    },
    {
      header: 'User Email',
      dataCell: (info) => info?.email_id,
      width: 25,
    },
    {
      header: 'Total Watch time',
      dataCell: (info) => convertDuration(info.total_watch_time),
      width: 13,
    },
    {
      header: 'Total Views',
      dataCell: (info) => info.total_views,
      width: 10,
    },
  ]

  const handleDateChange = (event, picker) => {
    picker.element.val(
      picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'),
    )
    setStartDate(moment.utc(picker.startDate).format('YYYY-MM-DD'))
    setEndDate(moment.utc(picker.endDate).format('YYYY-MM-DD'))
  }

  const handleCancel = (event, picker) => {
    picker.element.val('')
    setStartDate('')
    setEndDate('')
  }

  const handleNextPage = () => {
    userContentReportCall({
      params: {
        page: page + 1,
        start_date: startDate,
        end_date: endDate,
        device_type: deviceTypeFilter,
      },
    })
    setPage((page) => page + 1)
  }

  const handleMonthChange = (month) => {
    let monthObj = monthArr.find((info) => info.label === month)
    if (!monthObj) return
    setMonthFilterValue(month)
    setStartDate(monthObj.startDate)
    setEndDate(monthObj.endDate)
  }
  return (
    <CCard>
      <div className="d-flex justify-content-between mt-3 py-2">
        <div className="d-flex">
          <p className="mt-1">Filters:</p>
          <div className="mx-2">
            <CFormSelect
              size="sm"
              placeholder="Status"
              value={deviceTypeFilter}
              onChange={(e) => setDeviceTypeFilter(e.target.value)}
            >
              <option value="" selected disabled>
                Device Type
              </option>
              <option value={'WEB'}>Web</option>
              <option value={'MOBILE'}>Mobile</option>
              <option value={'TABLET'}>Tablet</option>
            </CFormSelect>
          </div>
          <div className="mx-3">
            {isDateRangeAllowed ? (
              <DateRangePicker
                ref={dateRangeRef}
                initialSettings={{
                  autoUpdateInput: false,
                  locale: { format: 'DD/MM/YYYY', cancelLabel: 'Clear' },
                  placeholder: 'Select Date Range',
                  maxDate: moment(),
                  minDate: moment().subtract(3, 'months'),
                }}
                onApply={handleDateChange}
                onCancel={handleCancel}
              >
                <CFormInput
                  size="sm"
                  type="text"
                  className=""
                  defaultValue=""
                  placeholder="Select Date Range"
                />
              </DateRangePicker>
            ) : (
              <CFormSelect
                size="sm"
                placeholder="month"
                value={monthFilterValue.label}
                onChange={(e) => handleMonthChange(e.target.value)}
              >
                {monthArr.map((info, idx) => (
                  <option key={idx} value={info.label}>
                    {info.label}
                  </option>
                ))}
              </CFormSelect>
            )}
          </div>
          <div className="mx-2">
            <CButton color="info" size="sm" className="text-white" onClick={applyFilter}>
              Apply
            </CButton>
          </div>
          {isDateRangeAllowed && (
            <p
              className="mt-1"
              style={{ color: '#1976d2', cursor: 'pointer' }}
              onClick={resetFilters}
            >
              Reset Filter
            </p>
          )}
        </div>
        <div className="d-flex">
          <div className="mx-2">
            <CButton color="success" size="sm" className="text-white" onClick={downloadExcel}>
              Download Excel
            </CButton>
          </div>
        </div>
      </div>
      <div style={{ zIndex: '0' }}>
        <SearchTable
          type={`User Content Report`}
          tableCardHeight={63}
          disableButton={true}
          disableSearch={true}
          marginDisable={true}
          textAlign={'center'}
          tableContent={userContentReportList}
          tableConfig={tableConfig}
          hashWidth={3}
          handleNextPage={handleNextPage}
          paginationEnable={
            userContentReportData &&
            !isEmpty(userContentReportData.data) &&
            userContentReportData.total > page * PAGE_SIZE
          }
          totalTableContent={userContentReportData?.total}
          noDataText={isDateRangeAllowed ? filterText : 'No User Content Report data available!'}
        />
      </div>
    </CCard>
  )
}

export default UserContentReport
